// @ts-nocheck
import { writable, derived } from 'svelte/store'
import { JSONAth } from '$lib/utils'
// import { BaseInterface } from '$lib/services/interfaces'
// import user from '$lib/stores/user'
// import Dexie from 'dexie'

export function hookStore(initial={}) {
    let { subscribe, set, update } = writable(initial)
    return {
        subscribe,
        set,
        setHook(hook, func, runOne=false) {
            let rfunc = runOne ? async () => {
                await Promise.resolve(func())
                subscribe(hooks => {
                    set(
                        Object.entries(hooks)
                        .filter(([e]) => e !== event)
                        .reduce((ac, [k, v]) => ({...ac, [k]: v}), {})
                    )
                })
                console.info(`UNSUSCRIBED ${hook} ${this.value}`)
            } : func
            subscribe(hooks => {
                hooks[hook] = rfunc
                console.log(`${hook} OK`, hooks)
                return hooks
            })
        },
        update,
        exists(hook) {
            let ret = false
            subscribe(hooks => {
                ret = hook in hooks
            })
            return ret
        },
        get value() {
            let ret
            subscribe(r => {
                ret = r
            })
            return ret
        },
        async run(hook) {
            subscribe(async hooks => {
                if(hook in hooks) {
                    await Promise.resolve(this.value[hook]())
                } else {
                    console.error(`No existe el hook ${hook}`)
                }
            })
        }
    }
}

export function liveQuery(collection, controller, initialHooks={}) {
    const { subscribe, set } = writable([])
    const locked = writable(false)
    let loading = writable(false)
    let updateDate = writable(null)
    let Hooks = hookStore(initialHooks)
    const lastFilter = writable((d) => d.toArray())
    const refresh = (_) => {
        return lastFilter.subscribe((f) => {
            return f(collection).then((r) => {
                set(r)
            })
        })
    }
    const setLockState = (state) => {
        if(typeof state == 'boolean') {
            console.log(`[${controller.name}] Set lock state to ${state}`)
            locked.set(state)
        }
    }
    const isLocked = () => {
        let ret = false
        locked.subscribe(r => {
            ret = r
        })
        return ret
    }
    
    const setLoadingState = (state) => {
        if(typeof state == 'boolean') {
            console.log(`[${controller.name}] Set loading state to ${state}`)
            loading.set(state)
        }
    }
    const isLoading = () => {
        let ret = false
        loading.subscribe(r => {
            ret = r
        })
        return ret
    }
    const getLoadingState = () => derived(loading, $loading => $loading, isLoading())
    const getLastUpdateState = () => derived(updateDate, $udate => $udate, null)

    const length = () => {
        let r = 0
        subscribe(items => r = items.length)
        return r
    }

    const get = async (id, syncEntry = false) => {
        return await collection
            .get(id)
            .then(async (r) => {
                if (r === undefined || syncEntry) {
                    const getPromise =
                        'getById' in controller
                            ? // Si tiene getById
                              () =>
                                  controller
                                      .getById(id)
                                      .then(async (req) =>
                                          req.ok ? await req.json() : null
                                      )
                            : // Si no tiene getById
                              () =>
                                  controller
                                      .get({ uuid: id })
                                      .then(async (req) =>
                                          req.ok
                                              ? await req
                                                    .json()
                                                    .then((r) =>
                                                        controller
                                                            .toItem(r)
                                                            ?.at(0)
                                                    )
                                              : null
                                      )
                    const request = await getPromise()
                        .then(async (res) => {
                            if (res) {
                                res = controller.convert(res)
                                await add(res)
                                return res
                            } else {
                                throw new Error(
                                    'El elemento no existe o no tiene permisos para visualizarlo.'
                                )
                            }
                        })
                        .catch((_) => {
                            throw new Error(
                                'El elemento no existe o no tiene permisos para visualizarlo.'
                            )
                        })
                    return request
                } else {
                    return r
                }
            })
            .catch((_) => {
                return _
            })
    }

    const add = async (item, convert=true) => {
        let tmp = convert ? controller.convert(item) : item
        let ret = collection
            .put(tmp)
            .then((r) => {
                refresh()
                return r
            })
            .catch((err) => {
                console.log(err)
                return null
            })
        return ret
    }

    const batchInitialization = async (params) => {
        setLockState(true)
        setLoadingState(true)
        if ('batchInitialization' in controller) {
            let onlineCount = await controller.count()
            console.log({onlineCount})
            if (onlineCount === 0) {
                setLockState(false)
                setLoadingState(false)
                refresh()
                console.log('exit batch initialization')
                return
            }
            console.log('continue batch initialization')
            let [firstBlock, getGenerator] = await controller.batchInitialization(params)
            console.log('start')
            await firstBlock.then(async items => {
                updateDate.set(new Date())
                for (let item of items) {
                    await collection.put(item)
                    refresh()
                }
            })
            console.log('end')
            setLoadingState(false)
            refresh()
            let generator = getGenerator()
            let task = new Promise(async (res, rej) => {
                let done = false
                try {
                    do {
                        setLoadingState(true)
                        await generator.next().then(async r => {
                            done = r.done
                            if (!done) for (let entry of r.value) {
                                await collection.put(entry)
                                refresh()
                            }
                        })
                        .catch(e => console.log(e))
                        .finally(() => {
                            updateDate.set(new Date())
                            refresh()
                        })
                        setLoadingState(false)
                    } while (!done)
                    setLockState(false)
                    res(true)
                } catch(e) {
                    setLockState(false)
                    console.info(e)
                    throw e
                }
            })
            Promise.resolve(task).catch(e => { console.info(e) })//.finally(() => setLockState(false))
            return
        }
        return
    }
    
    const setHook = (event, func, runOne=false) => {
        Hooks.setHook(event, func, runOne)
    }
    
    const sync = async (params = {}) => {
        refresh()
        if (isLocked()) {
            console.log(`[${controller.name}] Prevent sync`)
            refresh()
            return
        }
        setLoadingState(true)
        setLockState(true)
        let validFields = collection.schema.indexes.map(i => i.keyPath)
        let fparams = Object.entries(params)
            .filter(([k]) => validFields.includes(k))
            .reduce((acc, [k, v]) => ({...acc, [k]: v}), {})
        let entries = 'defaultFilter' in controller ? controller.defaultFilter(collection) : collection
        let matchedDocs = Object.keys(fparams).length ? entries.where(fparams) : entries
        await matchedDocs.toArray()
        .then(async (all) => {
            let onlineCount = await controller.count().then(r => r === null ? 1 : r)
            console.log({[controller.name]: onlineCount, localCount: all.length, fparams})
            if (all.length > 0 && onlineCount > 0) {
                refresh()
                let max = Math.max(...all.map((x) => x.fecha_modificacion))
                return controller.sync(collection, max).then((_) => {
                    updateDate.set(new Date())
                    refresh()
                })
            } else if (onlineCount > 0) {
                if ('batchInitialization' in controller) {
                    return batchInitialization({size: 100})
                } else {
                    return controller.get({ limit: 100 }).then(async (r) => {
                        if (r.ok) {
                            updateDate.set(new Date())
                            let data = await r.json()
                            if (data.data) {
                                data = data.data
                            }
                            for (let item of data) {
                                await collection.put(controller.convert(item))
                                refresh()
                            }
                            refresh()
                        }
                    })
                }
            }
            refresh()
        })
        .catch(e => console.log(e))
        .finally(() => {
            setLockState(false)
            setLoadingState(false)
        })
    }
    const _delete = async (id) => {
        await collection.delete(id)
        refresh()
    }
    const voidFecth = (_) =>
        new Promise((resolve, _) => {
            resolve(true)
        })
    
    const restore = async () => {
        setLockState(true)
        setLoadingState(true)
        return await JSONAth.restore(collection.name).then(async res => {
            if (res?.length) {
                let rawData = res.map(r => controller.convert(r))
                await collection.bulkPut(rawData).then(async r => {
                    let lastModificationDate
                    try {
                        if(rawData.length > 0) {
                            let firstEntry = rawData[0]
                            let fecha_modificacion = 'fecha_modificacion' in firstEntry ? Math.max(...rawData.map((x) => x.fecha_modificacion)) : rawData.map(x => x.modified_date).sort(
                                (a, b) => a > b ? -1 : (b > a ? 1 : 0) // Ordenar isodates en orden descendente
                            ).at(0)
                            lastModificationDate = fecha_modificacion ? new Date(typeof fecha_modificacion === 'string' ? fecha_modificacion : fecha_modificacion * 1000) : null
                            if (lastModificationDate) {
                                await controller.get({modified_date: lastModificationDate.toISOString()}).then(async r => {
                                    if(r.ok) {
                                        let data = await r.json()
                                        if (data.data) {
                                            data = data.data.map(r => controller.convert(r))
                                            await collection.bulkPut(data).then(() => {
                                                console.log('Finished')
                                            })
                                        }
                                    }
                                })
                            }
                            console.log({[collection.name]: {fecha_modificacion, lastModificationDate}})
                            updateDate.set(new Date())
                        }
                    } catch(e) {
                        console.error(e)
                    }
                    console.log(`Restore [${collection.name}] ${res.length} docs [${r}]`)
                })
            }
        }).catch(r => console.log(r))
        .finally(async () => {
            setLoadingState(false)
            setLockState(false)
            if(Hooks.exists('afterRestore')) {
                await Hooks.run('afterRestore').then(() => console.log('Collection '+collection.name))
            } else {
                console.warn(`[${collection.name}] No hay hook "afterRestore"`)
            }
        })
    }

    /**
     * @typedef {function(Ctx): Boolean} Assert
     * @param {Assert[]} asserts 
     * @param {function(Ctx): void} callback 
     */
    async function fixEntries(asserts, callback) {
        var context = {
            collection,
            controller,
            ret: []
        }
        let pass = true
        for (let assert of asserts) {
            let ret
            try { ret = await Promise.resolve(assert(context)) } catch(e) {
                ret = false
                console.error(e)
            }
            pass = pass && ret
        }
        setLoadingState(true)
        if(pass) await Promise.resolve(callback(context))
            .catch(e => {
                console.error(e)
            })
            .finally(() => {
                setLoadingState(false)
            })
    }
    
    const init = async (params = {}) => {
        if(controller?.backup === true) { try { await restore() } catch(e) { console.error(e) } }
        refresh()
        let lfilter
        console.log(`[${controller.name}] Init`)
        if(isLocked()) return voidFecth()
        lastFilter.subscribe((f) => (lfilter = f))
        let ret = await lfilter(collection).then((r) => {
            return r.length
        })
        console.log({[collection.name]: `Count: ${ret}`})
        refresh()
        if (ret === 0) {
            return sync(params)
        } else {
            refresh()
            sync(params)
            return voidFecth()
        }
    }
    return {
        subscribe,
        init,
        get,
        add,
        refresh,
        sync,
        liveQuery: (f) => {
            lastFilter.set(f)
            return f(collection).then((r) => set(r))
        },
        delete: _delete,
        load: refresh,
        reload: refresh,
        collection,
        isLocked,
        isLoading,
        fixEntries,
        setHook,
        length, getLoadingState, getLastUpdateState
    }
}
